import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, IBankMethodsDto } from '@/dtos';

export interface BankMethod {
  id: string;
  name: string;
  description: string;
}

const getBankMethods = () => api.get<IBankMethodsDto[]>(API_URL.ENUMS_BANK_METHODS);
const BANK_METHODS_QUERY_NAME = 'getBankMethods';
const useBankMethodsQuery = () => {
  const { data, isLoading } = useQuery([BANK_METHODS_QUERY_NAME], getBankMethods);
  const formatedData = useMemo(
    () =>
      data?.data?.map((item) => ({
        id: `${item.id}`,
        name: item.name || '',
        description: item.description || '',
      })),
    [data]
  );

  return {
    methods: formatedData || [],
    isLoading,
  };
};

export default useBankMethodsQuery;
